import { render } from "./AssignPlan.vue?vue&type=template&id=0c23e5a5&scoped=true"
import script from "./AssignPlan.vue?vue&type=script&lang=js"
export * from "./AssignPlan.vue?vue&type=script&lang=js"

import "./AssignPlan.vue?vue&type=style&index=0&id=0c23e5a5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c23e5a5"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QLayout});
